<template lang="html">
  <div class="projectBasicContainer">
    <h1>檢視員工</h1>
    <div>
      <qrcode
        :size="size"
        :cls="qrCls"
        :value="qrText"
        v-if="isQrcodeInfo"
      ></qrcode>
      <div v-else>無Qrcode資料</div>
      <Button type="error" @click="updateQrcode">更新Qrcode</Button>
    </div>
    <div class="tableContainer">
      <div class="fourColumn">
        <div class="title">姓名</div>
        <div class="text">{{ info.name }}</div>
        <div class="title">工號</div>
        <div class="text">{{ info.jobNumber }}</div>
        <div class="title">處</div>
        <div class="text">{{ info.division }}</div>
        <div class="title">部門</div>
        <div class="text">{{ info.department }}</div>
        <div class="title">課</div>
        <div class="text">{{ info.section }}</div>
        <div class="title">E-mail</div>
        <div class="text">{{ info.email }}</div>
        <div class="title">電話</div>
        <div class="text">{{ info.phone }}</div>
        <div class="title">權限</div>
        <div class="text">{{ info.authorize ? "是" : "否" }}</div>
        <div class="title">廠區</div>
        <div class="text">{{ info.factoryArea }}</div>
        <div class="title">可搭乘時段</div>
        <div class="text">
          <div v-for="range in timeRangeArray">
            <p>{{ range }}</p>
          </div>
        </div>
        <div class="title">支付限制（金額/趟）</div>
        <div class="text">{{ info.payLimit }}</div>
        <div class="title">搭乘限制（次數/月）</div>
        <div class="text">{{ info.takingLimit }}</div>
        <div class="title">付款密碼</div>
        <div class="text">{{ "****" }}</div>
        <div class="title">每月限制</div>
        <div class="text">{{ info.monthlyLimit }}</div>
      </div>
      <div class="twoColumn">
        <div class="title">備註</div>
        <div class="text">{{ info.note }}</div>
      </div>
    </div>
    <div class="btnContainer">
      <Button type="info" @click="edit">編輯</Button>
      <Button type="error" @click="archive">封存</Button>
      <router-link to="/employeelist" tag="Button">取消</router-link>
    </div>
  </div>
</template>

<script>
import { endPoint, loginResponse } from "@/utilities/api";
import jsCookie from "js-cookie";
import API from "../asset/js/API";
import Qrcode from "v-qrcode";
import { checkAuthorize } from "../asset/js/authorize";

export default {
  components: {
    Qrcode
  },
  created() {
    this.getInfo();
  },
  data() {
    return {
      info: {
        name: "",
        jobNumber: "",
        department: "",
        email: null,
        phone: "",
        factoryArea: "",
        startTime1: "",
        endTime1: null,
        startTime2: null,
        endTime2: null,
        startTime3: null,
        endTime3: null,
        authorize: false,
        takingLimit: null,
        payLimit: null,
        note: null
      },
      timeRange1: null,
      timeRange2: null,
      timeRange3: null,
      timeRangeArray: [],
      id: null,
      qrCls: "qrcode",
      qrText: "",
      size: 100,
      isQrcodeInfo: true
    };
  },
  mounted() {
    // this.qrText = `employee=${this.$route.params.id}`
  },
  methods: {
    updateQrcode() {
      API.put(`/employee/${this.id}/code`)
        .then(data => {
          const { result, success: isSuccess } = data;
          if (!isSuccess) {
            this.$Message.error(result);
          } else {
            this.getInfo();
            this.$Message.info(result);
          }
        })
        .catch(err => {
          this.$Message.error("網路異常，請再按一次");
        });
    },
    getInfo() {
      if (!checkAuthorize("inspectEmployee")) return;

      this.id = this.$route.params.id;
      API.get(`/employee/${this.id}`)
        .then(res => {
          const isSuccess = res.success;
          if (!isSuccess) {
            this.$Message.error(res.result);
          } else {
            this.info = res.result;
            if (res.result.verificationCode === null) {
              this.isQrcodeInfo = false;
            }
            this.qrText = `employee=${res.result.verificationCode}`;
            this.mergeTime();
          }
        })
        .catch(err => {
          this.$Message.error("網路異常，請再按一次");
        });
    },
    edit() {
      if (!checkAuthorize("editEmployee")) return;

      this.$router.push({
        name: "EditEmployee",
        params: { ...this.$data, id: this.id }
      });
    },
    archive() {
      if (!checkAuthorize("sealEmployee")) return;
      API.put(`/employee/${this.id}/seal`)
        .then(data => {
          const { result, success: isSuccess } = data;
          if (!isSuccess) {
            this.$Message.error(result);
          } else {
            this.$Message.info(result);
            this.$router.replace("/employeelist");
          }
        })
        .catch(err => {
          this.$Message.error("網路異常，請再按一次");
        });
    },
    mergeTime() {
      // 合併開始時間和結束時間成ㄧ字串
      this.timeRange1 = `${this.info.startTime1} ~ ${this.info.endTime1} / `;
      this.timeRange2 = `${this.info.startTime2} ~ ${this.info.endTime2} / `;
      this.timeRange3 = `${this.info.startTime3} ~ ${this.info.endTime3} / `;

      // 若有 null 值，用空字串取代
      if (!this.info.startTime1 || !this.info.endTime1) {
        this.timeRange1 = "";
      }
      if (!this.info.startTime2 || !this.info.endTime2) {
        this.timeRange2 = "";
      }
      if (!this.info.startTime3 || !this.info.endTime3) {
        this.timeRange3 = "";
      }
      this.timeRangeArray = [this.timeRange1, this.timeRange2, this.timeRange3];
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/components.scss";
</style>



// WEBPACK FOOTER //
// src/components/EmployeeInfo.vue